import textStyles from "../constants/textStyles";

/* eslint-disable sort-keys */
export default {
    Switch: {
        parts: [ "track", "thumb", ],
        baseStyle: {},
        sizes: {},
        variants: {
            default: {
                track: {
                    h: "6",
                    w: "14",
                    bgColor: "secondary.100",
                    border: "1px solid",
                    borderColor: "secondary.100",
                    fontSize: textStyles.p3.fontSize,
                    color: "white",
                    _checked: {
                        bgColor: "primary.400",
                        borderColor: "primary.400",
                    },
                    _focus: {
                        boxShadow: "none",
                    },
                    boxSizing: "content-box"
                },
                thumb: {
                    h: "6",
                    w: "6",
                    boxShadow: "0 2px 4px 0 rgb(0 0 0 / 30%)", // TODO: move to theme
                    _checked: {
                        transform: "translateX(2rem)"
                    }
                }
            },
        },
        defaultProps: {
            variant: "default",
        },
    }
};
